{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Modèles",
    "DESCRIPTION": "Consultez les modèles de message synchronisés depuis vos boîtes de réception WhatsApp. Pour créer ou modifier un modèle, gérez-le chez votre fournisseur.",
    "COUNT": "{n} modèle | {n} modèles",
    "LEARN_MORE": "En savoir plus sur les modèles WhatsApp",
    "SYNC_TEMPLATES": "Synchroniser les modèles",
    "SYNC_SUCCESS": "La synchronisation des modèles a démarré pour toutes les boîtes de réception WhatsApp. Les mises à jour peuvent prendre quelques minutes.",
    "PARTIAL_SYNC_ERROR": "La synchronisation des modèles a démarré pour certaines boîtes de réception WhatsApp, mais pas pour les autres.",
    "SYNC_ERROR": "Impossible de démarrer la synchronisation des modèles. Veuillez réessayer.",
    "SEARCH_PLACEHOLDER": "Rechercher par contenu ou par nom...",
    "MANAGE_IN_META": "Gérer dans Meta",
    "LOADING": "Chargement des modèles WhatsApp...",
    "EMPTY": "Aucun modèle WhatsApp trouvé.",
    "NO_RESULTS": "Aucun modèle ne correspond à vos filtres.",
    "FETCH_ERROR": "Impossible de charger les modèles WhatsApp. Veuillez réessayer.",
    "PARTIAL_FETCH_ERROR": "Certains modèles WhatsApp n'ont pas pu être chargés. Veuillez réessayer.",
    "LAST_SYNC_ATTEMPT": "Dernière tentative de synchronisation le {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Non soumis pour approbation WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Toutes les boîtes de réception",
      "ALL_LANGUAGES": "Toutes les langues",
      "ALL_TYPES": "Tous les types"
    },
    "TYPES": {
      "TEXT": "Texte",
      "IMAGE": "Image",
      "VIDEO": "Vidéo",
      "DOCUMENT": "Document",
      "CALL_TO_ACTION": "Appel à l'action",
      "COPY_CODE": "Copier le code"
    },
    "PREVIEW": {
      "TITLE": "Aperçu du modèle",
      "DESCRIPTION": "Aperçu de l'affichage de ce modèle dans WhatsApp.",
      "OPEN": "Aperçu de {name}",
      "CLOSE": "Fermer l'aperçu",
      "DETAILS": "Détails du modèle",
      "STATUS": "Statut",
      "TYPE": "Type de contenu",
      "CATEGORY": "Catégorie",
      "LANGUAGE": "Langue",
      "INBOXES": "Boîtes de réception"
    }
  }
}
